<template>
  <form :action="route" method="POST" class="form-horizontal">
    <input type="hidden" name="_token" :value="csrfToken" />

    <div
      class="modal-content"
      style="width: inherit; height: inherit; margin: 0 auto"
    >
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 id="modal_title" class="modal-title">
          Add Vendor Commission Adjustment
        </h4>
      </div>
      <div class="modal-body">
        <input
          id="commission_id"
          type="hidden"
          name="id"
          :value="vendorCommission.id"
        />

        <div class="row" style="padding-bottom: 10px">
          <div class="col-xs-12">
            <table class="table" align="left">
              <tr>
                <th class="col-xs-4">SKU</th>
                <td>
                  {{ vendorCommission.sku }}
                </td>
              </tr>
              <tr>
                <th class="col-xs-4">Cycle:</th>
                <td>
                  {{ vendorCommission.cycle }}
                </td>
              </tr>
              <tr>
                <th class="col-xs-4">Quantity:</th>
                <td>
                  {{ vendorCommission.qty }}
                </td>
              </tr>
              <tr>
                <th class="col-xs-4">Unit Price</th>
                <td>
                  {{ vendorCommission.unit_price | currency }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <hr />

        <div class="col-xs-12" style="padding: 0">
          <label class="control-label" for="adj_type">Adjustment Type:</label>
          <select
            id="adj_type"
            v-model="selectedType"
            class="form-control"
            name="adj_type"
            required
          >
            <option value="" selected disabled>
              Select Adjustment Type...
            </option>
            <option
              v-for="(adjustmentType, i) in adjustmentTypes"
              :key="'adjustmentType_' + i"
              :value="adjustmentType"
            >
              {{ adjustmentType | capitalize }}
            </option>
          </select>
        </div>

        <div class="col-xs-12" style="padding: 0">
          <label class="control-label" for="adj_reason">
            Adjustment Reason:
          </label>
          <select
            id="adj_reason"
            v-model="selectedReason"
            class="form-control"
            name="adj_reason"
            required
          >
            <option v-if="selectedType" value="" selected disabled>
              Select Adjustment Reason...
            </option>
            <option v-else value="" selected disabled>
              Select Adjustment Type Above...
            </option>
            <option
              v-for="(reasonText, reasonId) in availableReasons"
              :key="'reason_' + reasonId"
              :value="reasonId"
            >
              {{ reasonText }}
            </option>
          </select>
        </div>

        <div class="col-xs-12" style="padding: 0">
          <label class="control-label" for="adj_quantity">
            Adjustment Quantity:
          </label>
          <select
            id="adj_quantity"
            v-model="selectedQuantity"
            class="form-control"
            name="adj_quantity"
            required
          >
            <option value="0" selected disabled>0</option>
            <option
              v-for="quantity in availableQuantity"
              :key="'quantity_' + quantity"
              :value="quantity"
            >
              {{ quantity }}
            </option>
          </select>
        </div>

        <div class="col-xs-12" style="padding: 0">
          <label class="control-label" for="adj_description">
            Description:
          </label>
          <input
            id="adj_description"
            class="form-control"
            type="text"
            name="description"
            required
          />
        </div>

        <div class="clearfix"></div>
      </div>
      <div class="modal-footer">
        <button
          type="submit"
          class="btn btn-primary"
          @click="handleClick($event)"
        >
          Save
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  filters: {
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    currency(amount) {
      return `$ ${amount.toFixed(2)}`;
    },
  },
  props: {
    route: {
      type: String,
      required: true,
    },
    vendorCommission: {
      type: Object,
      required: true,
    },
    adjustmentTypes: {
      type: Array,
      required: true,
    },
    adjustmentReasons: {
      type: Object,
      required: true,
    },
    availableQuantities: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      csrfToken: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      selectedType: "",
      selectedReason: "",
      selectedQuantity: 0,
      availableQuantity: 0,
    };
  },
  computed: {
    availableReasons() {
      return this.adjustmentReasons[this.selectedType];
    },
  },
  watch: {
    selectedType() {
      this.selectedReason = "";
      this.availableQuantity = this.availableQuantities[this.selectedType] ?? 0;
      this.selectedQuantity = 0;
    },
  },
  methods: {
    handleClick(e) {
      e.target.innerHTML = `Wait... <i class="fa fa-spinner fa-spin" style="font-size:24px"></i>`;
      e.target.classList.add("disabled");
    },
  },
};
</script>
